import {Component, OnDestroy, OnInit} from "@angular/core";
import {WorkflowService} from "../workflow.service";
import {ProjectService} from "../../project/project.service";
import {Subscription} from "rxjs";
import {WorkflowStepStatus} from "../models/workflow-step-status.enum";

@Component({
  selector: "project-rejection-message",
  templateUrl: "./project-rejection-message.template.pug",
})
export class ProjectRejectionMessageComponent implements OnInit, OnDestroy {
  private workflowStatusSubscription: Subscription;

  rejectedReason: string;
  isProjectRejected: boolean = false;
  allowUnRejectProject: boolean = false;

  constructor(private workflowService: WorkflowService, private projectService: ProjectService) {}

  ngOnInit(): void {
    this.workflowStatusSubscription = this.workflowService.workflowStatus.subscribe(() => {
      this.updateDisplay();
    });
  }

  ngOnDestroy(): void {
    this.workflowStatusSubscription.unsubscribe();
  }

  updateDisplay(): void {
    if (this.workflowService.workflowConfig.type === "project") {
      this.isProjectRejected = this.workflowService.workflowConfig.target.rejected;
      this.rejectedReason = this.workflowService.workflowConfig.target.rejectedReason;
      this.allowUnRejectProject = this.workflowService.workflowConfig.target.allowUnReject;
    }
  }

  async removeProjectRejection(): Promise<void> {
    await this.projectService.unRejectProject(this.workflowService.workflowConfig.projectId);
    const status = (this.workflowService.currentStep || {status: null}).status || WorkflowStepStatus.InProgress;
    await this.workflowService.setStepStatus(status);
  }
}
